import { PaginatedGalleryRoute } from './types'

export const NAV_BUTTON_SIZE = '48px'
export const NAV_BUTTON_SIZE_MOBILE = '40px'
export const PAGINATED_GALLERY_ROUTE_NAMES: PaginatedGalleryRoute[] = [
  'content',
  'search',
  'dynamic',
  'pay-per-click',
  'collections',
]
